import { createModule } from '~/factories/store'
import actions from '~/store/modules/shared/parking/actions'
import getters from '~/store/modules/shared/parking/getters'
import mutations from '~/store/modules/shared/parking/mutations'
import state from '~/store/modules/shared/parking/state'

export default createModule({
  actions,
  getters,
  mutations,
  state
})
